import { Flex, theme } from '../../2022-component-library';
import { VideoConsultation } from '../../components';
import { useAppointment } from '../../context/appointmentContext';

const PatientEndOfTest = () => {
  const { appointment } = useAppointment();

  return (
    <Flex column centered width='100%' height='100vh' backgroundColor={theme.colors.backgroundShade}>
      <VideoConsultation userInfo={{ ...appointment.currentAppointment, ...appointment.currentUser }} />
    </Flex>
  );
};

export default PatientEndOfTest;
